"use client";

import { Avatar, Box, Button, Dialog, Grid2, Typography } from "@repo/ui";
import Section from "../components/Section";

import QueriesForm from "@/components/forms/QueriesForm";
import Link from "next/link";
import { checkFirstString, hasData } from "@/lib/helpers";
import { Suspense, useState } from "react";
import RequestCallbackForm from "@/components/forms/RequestCallbackForm";
import { usePathname } from "next/navigation";
import PhoneIcon from "@spoctech/icons/PhoneIcon";
import MailIcon from "@spoctech/icons/MailIcon";

type QueriesProps = {
  sectionInfo: PageSections;
  data?: {
    heading?: string;
    subHeading?: string;
    buttonText?: string;
    buttonAction?: string;
    serviceId?: number;
    list?: {
      icon?: string;
      label?: string;
      value: string;
    }[];
  };
};
const Queries = ({ data, sectionInfo }: QueriesProps) => {
  const [open, setOpen] = useState(false);
  const pathname = usePathname();

  if (!hasData(data)) return null;

  return (
    <Section id={sectionInfo.sectionId} className={sectionInfo.sectionClass}>
      <Grid2 container columnSpacing={4} align="center">
        <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
          <Box>
            <Typography variant="h2" gutterBottom>
              {data?.heading || "Do you have any queries"}
            </Typography>
            <Typography variant="body1" className="text-gray-600">
              {data?.subHeading || "Talk to our expert. We’re available 24/7"}
            </Typography>
            <Box flex mt="md" className="flex-col sm:flex-row gap-4">
              {data?.list?.map((item, index) => (
                <Box flex key={`phone-email-${index}`}>
                  <Avatar
                    className="mr-4 !bg-white shadow-md !text-primary-main"
                    size="large"
                  >
                    {item?.icon === "PhoneIcon" ? <PhoneIcon /> : <MailIcon />}
                  </Avatar>
                  <Box flex flexDirection="col" justifyContent="between">
                    <Typography
                      variant="subtitle1"
                      render={<div />}
                      className="fw-sb"
                    >
                      {item.label || "Email/Call us"}
                    </Typography>
                    <Typography variant="body2" className="gray-text">
                      <Link href={checkFirstString(item.value || "#")}>
                        {item.value || "info(at)spoclearn(dot)com"}
                      </Link>
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>
          <Box className="my-6">
            <Button
              color="primary"
              variant="contained"
              size="large"
              label={data?.buttonText || "Request a callback"}
              onClick={() => setOpen(true)}
            />
          </Box>
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
          <Suspense>
            <QueriesForm
              columns={2}
              color="primary"
              formHeading="Enquire us!"
              buttonLabel="Enquire now"
              serviceId={
                pathname.includes("/course/") ||
                pathname.includes("/consulting/")
                  ? data?.serviceId?.toString()
                  : ""
              }
            />
          </Suspense>
        </Grid2>
      </Grid2>
      {/* Request callback popup */}
      <Dialog
        open={open}
        onOpenChange={setOpen}
        maxWidth="md"
        title="Request Callback"
      >
        <RequestCallbackForm onSuccess={() => setOpen(false)} />
      </Dialog>
    </Section>
  );
};

export default Queries;
